export const parseLookupItems = (listItems) => {
  if (!listItems) return [];
  if (Array.isArray(listItems)) return listItems;
  if (typeof listItems === 'string') {
    try {
      const parsed = JSON.parse(listItems);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

export const slugifyWorkAreaCode = (label) =>
  String(label || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '_')
    .replace(/^_|_$/g, '');

export const buildWorkAreaLabelMap = (listItems) => {
  const map = {};
  parseLookupItems(listItems).forEach((item) => {
    const code = item?.code;
    if (code) {
      map[code] = item.label || code;
    }
  });
  return map;
};

export const resolveWorkAreaLabel = (workAreaCode, workAreaLabels = {}) => {
  if (!workAreaCode) return '';
  return workAreaLabels[workAreaCode] || workAreaCode;
};

export const formatPositionLabel = (role, workAreaLabels = {}) => {
  const name = role?.roleName || role?.role_name || 'Position';
  const code = role?.workAreaCode || role?.work_area_code;
  const area = resolveWorkAreaLabel(code, workAreaLabels);
  return area ? `${name} (${area})` : name;
};

export const buildLookupListUrl = (baseUrl, listCode, tenantId) => {
  const params = new URLSearchParams({ list_code: listCode });
  if (tenantId) {
    params.set('tenant_id', tenantId);
  }
  return `${baseUrl}conductor/lookup-list?${params.toString()}`;
};

export const ensureWorkAreaInLookup = async ({
  baseUrl,
  headers = {},
  tenantId,
  code,
  label,
}) => {
  if (!tenantId || !code) return null;
  const response = await fetch(`${baseUrl}conductor/lookup-list/items`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    body: JSON.stringify({
      list_code: 'WORK_AREA',
      tenant_id: tenantId,
      code,
      label: label || code,
    }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || err.message || `Failed to save work area: ${response.status}`);
  }
  return response.json();
};

export const removeWorkAreaFromLookup = async ({
  baseUrl,
  headers = {},
  tenantId,
  code,
}) => {
  if (!tenantId || !code) return null;
  const response = await fetch(`${baseUrl}conductor/lookup-list/items`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    body: JSON.stringify({
      list_code: 'WORK_AREA',
      tenant_id: tenantId,
      code,
    }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || err.message || `Failed to delete work area: ${response.status}`);
  }
  return response.json();
};

export const fetchWorkAreaLabelMap = async (baseUrl, headers = {}, tenantId = '') => {
  try {
    const response = await fetch(buildLookupListUrl(baseUrl, 'WORK_AREA', tenantId), {
      method: 'GET',
      headers,
    });
    if (!response.ok) return {};
    const data = await response.json();
    return buildWorkAreaLabelMap(data?.list_items ?? data?.listItems);
  } catch {
    return {};
  }
};
